<template>
  <div class="col-md-6 col-sm-6 col-xs-6 q-pr-md">
    <q-table
      flat
      table-header-class="bg-accent text-width-bold"
      :rows="listaUsuarios"
      :columns="columns"
      :loading="disable"
      class="tabela-tamanho-fixo q-mt-sm"
      :rows-per-page-options="[0]"
      dense
      hide-bottom
      hide-pagination
      selection="single"
      row-key="id"
      v-model:selected="selected"
      no-data-label
      @request="handleRequest"
    >
      <template v-slot:top>
        <section class="row align">
          <div class="row col-12 items-center justify-between">
            <span class="text-h6 text-brand-5">Lista Usuarios</span>
            <q-checkbox
              v-model="ferramentaAssosiada"
              label="Somente usuários com Item"
              true-value="1"
            />
          </div>
          <div class="row col-12 justify-end">
            <q-input
              class="q-pl-md"
              rounded
              outlined
              dense
              debounce="300"
              v-model="filter"
              placeholder="Pesquisar"
            >
              <template v-slot:append>
                <q-icon name="search"></q-icon>
              </template>
            </q-input>
          </div>
        </section>
      </template>
    </q-table>
    <div class="row justify-start q-mt-md">
      <q-pagination
        :disable="disable"
        v-model="pagination.page"
        color="brand-5"
        active-color="secondary"
        active-text-color="white"
        :max="pagesNumber"
        :max-pages="5"
        :boundary-numbers="false"
        :direction-links="true"
        size="sm"
      />
    </div>
  </div>
</template>

<script>
import { ref, onMounted, watch, computed } from "vue";
//import { useRouter } from "vue-router";
import { useStore } from "vuex";

export default {
  name: "SelectComponentResponsaveis",
  props: ["atualizar"],
  setup(props, { emit }) {
    const store = useStore();
    //const router = useRouter();
    const unidade = ref({
      id: "",
      nome: "",
    });
    const filter = ref("");
    const disable = ref(true);
    const selected = ref([]);
    const listaUnidades = ref([]);
    const listaUsuarios = ref([]);
    const ferramentaAssosiada = ref(false);
    const selecionaImagem = ref(false);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 6,
      rowsNumber: 6,
    });

    const columns = [
      {
        name: "name",
        label: "Usuário",
        field: "name",
        align: "left",
      },
      {
        name: "email",
        label: "Email",
        field: "email",
        align: "left",
      },
    ];

    let listarUsuarios = async (page = 0, rowsPerPage = 6) => {
      disable.value = true;
      try {
        let resposta = await store.dispatch("fer/listarUsuarios2", {
          vendor_id: store.state.org.unidadeData.id,
          perPage: rowsPerPage,
          page: page,
          search: filter.value,
          vinculado_ferramenta: ferramentaAssosiada.value,
        });

        listaUsuarios.value = resposta.data.results.data;
        pagination.value.rowsPerPage = resposta.data.results.per_page;
        pagination.value.rowsNumber = resposta.data.results.total;
        pagination.value.page = resposta.data.results.current_page;

        disable.value = false;
      } catch (error) {
        console.error(error);
      }
    };

    onMounted(() => {
      listarUsuarios();
    });

    watch(
      () => ferramentaAssosiada.value,
      () => {
        listarUsuarios();
      }
    );

    watch(
      () => selected.value,
      () => {
        emit("selectValue", selected.value);
      }
    );

    watch(
      () => filter.value,
      () => {
        listarUsuarios();
      }
    );

    watch(
      () => props.atualizar,
      () => {
        listarUsuarios();
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        listarUsuarios();
      }
    );

    const handleRequest = async () => {
      listarUsuarios(pagination.value.page, pagination.value.rowsPerPage);
    };

    watch(
      () => pagination.value.page,
      () => {
        handleRequest();
      }
    );

    return {
      unidade,
      selecionaImagem,
      listaUsuarios,
      listaUnidades,
      columns,
      selected,
      disable,
      ferramentaAssosiada,
      filter,
      handleRequest,
      pagination,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
    };
  },
};
</script>

<style scoped>
.align {
  align-items: center;
  justify-content: space-between;
}
</style>
